import { render, staticRenderFns } from "./publicShare.vue?vue&type=template&id=3f172b08&scoped=true&"
import script from "./publicShare.vue?vue&type=script&lang=js&"
export * from "./publicShare.vue?vue&type=script&lang=js&"
import style0 from "./publicShare.vue?vue&type=style&index=0&id=3f172b08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f172b08",
  null
  
)

export default component.exports